module.exports = __webpack_public_path__ + "videos/hero-vid_en.ede4226.mp4";